import type { WysiwygBtnSettings } from '@Types/Shared/Common';

import { Animation } from '@Views/Shared/Button/Animation';
import { ArrowBold, ArrowFull, ArrowLong, ArrowSmall } from '@Views/Shared/Icons';

type ReadMoreType = {
	textLabel: string | undefined;
	readMoreStyle?: WysiwygBtnSettings;
	className?: string;
};

export default function ReadMoreBtn(props: ReadMoreType) {
	const { readMoreStyle } = props;

	return (
		<>
			{readMoreStyle?.btnStyle?.btnIsBasicLink ? <BasicBtn {...props} /> : <Complexbtn {...props} />}
		</>
	);
}

const BasicBtn = (props: ReadMoreType) => {
	const { textLabel, readMoreStyle, className } = props;

	const classes: string[] = [];

	const basicStyle = `relative inline-block transition-colors last:mr-0 w-fit ${className}`;

	if (readMoreStyle?.style === 'a') {
		classes.push(
			`${readMoreStyle?.ClassName} ${readMoreStyle?.btnStyle?.btnHasIcon && readMoreStyle?.btnStyle?.btnDecorationElement === 'underline' ? ' underline underline-offset-4' : ''}`
		);
	} else {
		classes.push(readMoreStyle?.ClassName ? readMoreStyle?.ClassName : '', basicStyle);
	}

	classes.push(
		`${readMoreStyle?.ClassName ? readMoreStyle?.ClassName : ''} ${readMoreStyle?.btnStyle?.hasUnderline ? ' underline underline-offset-4' : ''}`
	);

	return <span className={classes.join(' ')}>{textLabel}</span>;
};

const Complexbtn = (props: ReadMoreType) => {
	const { textLabel: label, readMoreStyle, className } = props;

	return (
		<Animation
			as={'span'}
			className={`relative inline-flex w-fit items-center gap-2 transition-colors last:mr-0 ${readMoreStyle?.ClassName} ${className}`}
			animation={readMoreStyle?.animation}
		>
			<span
				className={`${readMoreStyle?.btnStyle?.btnHasIcon && readMoreStyle?.btnStyle?.btnDecorationElement === 'underline' ? 'underline underline-offset-4' : ''}`}
			>
				{label}
			</span>
			{readMoreStyle?.btnStyle?.btnHasIcon && (
				<>
					{readMoreStyle?.btnStyle?.btnDecorationElement === 'long' && (
						<ArrowLong
							width='20'
							className='transition-transform group-hover:translate-x-2 group-hover:duration-300 group-hover:ease-in-out'
						/>
					)}

					{readMoreStyle?.btnStyle?.btnDecorationElement === 'short' && (
						<ArrowSmall
							width='20'
							className='transition-transform group-hover:translate-x-2 group-hover:duration-300 group-hover:ease-in-out'
						/>
					)}

					{readMoreStyle?.btnStyle?.btnDecorationElement === 'full' && (
						<ArrowFull className='transition-transform group-hover:translate-x-2 group-hover:duration-300 group-hover:ease-in-out' />
					)}

					{readMoreStyle?.btnStyle?.btnDecorationElement === 'bold' && (
						<ArrowBold className='transition-transform group-hover:translate-x-2 group-hover:duration-300 group-hover:ease-in-out' />
					)}
				</>
			)}
		</Animation>
	);
};
